import _regeneratorRuntime from "@babel/runtime/regenerator";
import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import { createContext } from 'react';
import { applyMiddleware, compose, createStore } from 'redux';
import { connect as originalConnect } from 'react-redux';
import { select, take } from 'redux-saga/effects';
import { Map, setIn } from 'immutable';
import { reducer, regHandlers } from './reducer';
import { commitSagas, regSaga, runSaga, sagaMiddleware } from './saga';
var composeEnhancers = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
  name: '@kineticdata/react'
}) : compose;
var store = createStore(reducer, Map(), composeEnhancers(applyMiddleware(sagaMiddleware)));

var dispatch = function dispatch(type, payload) {
  return store.dispatch({
    type: type,
    payload: payload
  });
};

var dispatcher = function dispatcher(type) {
  return function (payload) {
    return store.dispatch({
      type: type,
      payload: payload
    });
  };
};

var action = function action(type, payload) {
  return {
    type: type,
    payload: payload
  };
};

var commitStore = function commitStore() {
  commitSagas();
};

var context = createContext();

var connect = function connect() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return originalConnect.apply(void 0, _toConsumableArray(setIn(args, [3, 'context'], context)));
};

export { action, context, commitStore, connect, dispatch, dispatcher, reducer, regHandlers, regSaga, runSaga, store };
export var selectWaiting = /*#__PURE__*/_regeneratorRuntime.mark(function selectWaiting(selector) {
  var value;
  return _regeneratorRuntime.wrap(function selectWaiting$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!true) {
            _context.next = 12;
            break;
          }

          _context.next = 3;
          return select(selector);

        case 3:
          value = _context.sent;

          if (!value) {
            _context.next = 8;
            break;
          }

          return _context.abrupt("return", value);

        case 8:
          _context.next = 10;
          return take();

        case 10:
          _context.next = 0;
          break;

        case 12:
        case "end":
          return _context.stop();
      }
    }
  }, selectWaiting);
});